module.exports = __webpack_public_path__ + "static/media/fk.c063ef38.svg";